export default {
  criptonomia: 'Criptonomia provides solutions for:',
  landing: {
    title: 'Criptonomia',
    subtitle:
      'We develop solutions focused on benefiting busines process with the use of emerging technologies.',
    btn: 'Learn about our solutions',
    products: [
      {
        title: 'Exchange Whitelabel',
        subtitle:
          'Trading exchange technology for digital assets with its own order engine, complete back office and multiple integrations.',
      },
      {
        title: 'Asset Tokenization',
        subtitle:
          'Tokeniztion of high value-added assets with a focus on gaining liquidity for non-liquid assets and facilitated price discovery.',
      },
      {
        title: 'Document records',
        subtitle:
          'Registration of redundant Blockchain sensitive documents and information for process compliance.',
      },
    ],
  },
  specialty: {
    title: 'Blockchain expertise',
    subtitle: '',
    p:
      'Criptonomia specializes in benefiting corporate processes through blockchain technology, promoting a new level of transparency between customers and suppliers, process audibility and registration evidence.',
    paragraph:
      'We are creating comprehensive technology solutions involving Blockchain for customers and partners, in a wide range of sectors such as industrial, financial and any type of organization that works with sensitive assets and information.',
  },
  carousel: {
    features: [
      {
        preTitle: 'Reconciliation of distributed payments',
        title:
          'ArcelorMittal has included Blockchain on its emerging technologies radar for industry 4.0.',
        description:
          'A consultative process was carried out focusing on the survey and selection of use cases for the elaboration of a pilot project based on technology Blockchain. The distributed payment reconciliation system between supplier and customer can transform an accounting-bank reconciliation, which relates a tax document with its due discharge, from a centralized process that can last up to 24 hours for a collaborative of approximately 3 minutes, confirmation of the transaction on the Ethereum Blockchain.',
      },
      {
        preTitle: 'Tokenization',
        title: 'Tokenization of the Brazilian Real',
        description:
          'BRLT is a symmetric token for BRL with one to one parity. The creation of BRLT was motivated by the desire to deliver to the Brazilian society the experiment of a stable, secure and auditable digital token capable of transacting value.',
      },
      {
        preTitle: 'Courses and Lectures',
        title: 'Blockchain for Executives - A practical approach',
        description:
          'Blockchain for executives is a practical course for C - Levels, Directors and Managers to understand how to apply technology in their organization in order to generate real value. Much is heard about Blockchain technology at project meetings but the zeitgeist of the Brazilian corporate scenario is of little practical implementation. If you have a decision making position in any industry and want to understand how to implement blockchain technology to solve your organization problems, join us.',
      },
      {
        preTitle: '“Self-Auditing” for financial operations',
        title: 'Distributed real-time trading record',
        description:
          'Currently, when we are faced with performance information on investment strategies or financial products, it is up to us to have faith in the information provider. Large institutions generally resort to external auditing to confirm their performance in the market. With the Krypton products, the process of auditing records is more efficient and economical. True Record was created, a streaming record system that records the clients operations on the Blockchain at the moment they occurred with a unique key and publishes it so that anyone can check in real time the performance history of the fund in question.',
      },
      {
        preTitle: 'Tokenization of Precatories',
        title:
          'The Mercado Bitcoin, one of Brazil is most admired crypto exchanges, has tokenized precatory bonds.',
        description:
          'We were chosen as a technical supplier for structuring smart contracts that gave rise to the first tokens from Brazilian precatorios. We work assisting them in the technical structuring for the first tokenized financial assets widely traded in the history of Latin America.',
      },
    ],
  },
  callToAction: {
    title: 'CUSTOM INTELLIGENT CONTRACTS',
    subtitle:
      'Introduce us to the problems in your industry or the level of transparency and compliance you want to achieve and Kryptonite will help you understand whether smart contracts can leverage processes in the context of your organization.',
    express: 'Contact Whatsapp Express',
  },
  products: {
    title: 'Our Products',
    lgpdTitle:
      'How to ensure that your organization has complied with LGPD good practices after a data leak?',
    lgpdSubtitle:
      'Blockchain records guaranteed by scryptum can serve as proof of cryptography and good practices in order to protect your institution from the risk of millionaire fines.',
    plans: 'View plans',
    know: 'Know solution',
    obj: [
      {
        title: 'SCRYPTUM',
        subtitle:
          'Information security tool. Store and record sensitive information for public scrutiny, future audit or reconciliation in an economically efficient way. Protect your organization, internal and external processes in the context of GPDR.',
        link: 'scryptum',
        h4:
          'Scryptum - Protection of sensitive processes and information including organizational in context GPDR.',
        p1:
          'Store and record sensitive information for irrefutable proof in the future. Thanks to Blockchain technology it is possible to establish records independently but that allow public verification.',
        p2:
          'Scryptums solution has been sought by companies to solve problems / games of incomplete trust in the relationship of customer / supplier or business partners and as an investment in proving good practices for organizational protection in the context of GPDR.',
        features: [
          {
            title: 'Register on Blockchain',
            subtitle:
              'Record cryptographic references of confidential information to obtain irrefutable proof of no changes in various distributed protocols.',
          },
          {
            title: 'Transparency',
            subtitle:
              'If transparency is desired, the most suitable platform for data storage is Blockchain, otherwise the recorded data can be stored in an encrypted form and only be accessible by players in the given context.',
          },
          {
            title: 'Integrity',
            subtitle:
              'Thanks to Blockchain technology, once inserted, the data is immutable on the network. The disposition of transactions and network operation guarantee the security that your data will not be altered.',
          },
        ],
        featuresMid: [
          {
            title: 'Privacy and Industrial Secret',
            subtitle:
              'Cryptographic data references can be stored in a way that any and all industrial secrets are preserved and treated with the highest degree of privacy.',
          },
          {
            title: 'Removal of intermediaries',
            subtitle:
              'Rather than allocating funds to hire third parties to claim that their data is true, there are some situations, where external auditors may be replaced by streaming real-time recording of data on the Blockchain that fulfills the same function as more sophisticated audits.',
          },
          {
            title: 'Self-compliance',
            subtitle:
              'Improve internal and external compliance processes with suppliers and partners with a tool that helps ensure institutional peace of mind against fraud, evidence of good management, against allegations of malpractice and negligence, among other guarantees.',
          },
        ],
      },
      {
        title: 'TASSET',
        subtitle:
          'TASSET - A secure platform for issuing digital asset tokens using Blockchain technology.',
        link: 'tasset',
        h4:
          'TASSET - A secure platform for issuing digital asset tokens using Blockchain technology.',
        p1:
          'Transform traditional securities into tokens to provide a variety of benefits: greater liquidity, lower transaction costs, faster and automated settlement times, fractional ownership and, most importantly, transparency and security provided by Blockchain.',
        p2: '',
        features: [
          {
            title: 'Commodities',
            subtitle:
              'Transform physical assets into tradable digital assets in a market with greater liquidity and a lower barrier to entry into asset classes traditionally dominated by institutional investors',
          },
          {
            title: 'Works of art',
            subtitle:
              'Give retail investors access to the fine arts market and artists an opportunity to benefit from their works of art as equitable investments',
          },
          {
            title: 'Real Estate',
            subtitle:
              'Offer retail investors the ability to own building tokens, symbolizing their real estate and properties. Illiquid assets that are too expensive to trade, like this one, gain greater liquidity through tokenization.',
          },
        ],
        featuresMid: [
          {
            title: 'Integrity',
            subtitle:
              'Thanks to Blockchain technology, once inserted, the data is immutable on the network. The organization of transactions and the operation of the network ensures the security that your data will never be changed.',
          },
          {
            title: 'Possibilities',
            subtitle:
              'Create your own security token that pays dividends, shares profits, pays interest, or invests in other tokens or assets to generate profits for token holders.',
          },
          {
            title: 'Regular',
            subtitle:
              'Transform traditional securities or your assets into tokens that comply with security regulations.',
          },
        ],
      },
      {
        title: 'HIVE',
        subtitle:
          'Consensus mechanisms are applications that specialize in establishing a foundation of absolute trust between two or more organizations.',
        link: 'hivemecanism',
        h4:
          'Consensus mechanisms are applications that specialize in establishing a foundation of absolute trust between two or more organizations.',
        p1:
          'A decentralized application that is non-manipulable and does not belong to any of the two parts that can be used by both isonomically and preserving information security. All participant actions as well as measurement status are recorded on the Blockchain and an arbitration chamber is developed to settle disputes.',
        p2: '',
        features: [
          {
            title: 'Proof of Consensus',
            subtitle:
              'Thanks to Blockchain technology, we were able to reach consensus in a simple way. The immutability of records guarantees, for better or worse, the authenticity of the information.',
          },
          {
            title: 'Transparency',
            subtitle:
              'Auditability in business rules. No records or evidence are tampered with or disappear since they are immutable and eternal and this information and people can be audited and compared at any time.',
          },
          {
            title: 'Financial automation',
            subtitle:
              'Armed with a smart contract, we were able to fully automate the flow of payments according to the variables imposed.',
          },
        ],
        featuresMid: [
          {
            title: 'Technical and commercial',
            subtitle:
              'Measurements and actions of participants are recorded on Blockchain, state-of-the-art technology for non-manipulable records.',
          },
          {
            title: 'Finance',
            subtitle:
              'Payment calculated without human interference and can be completely automated.',
          },
          {
            title: 'Legal',
            subtitle:
              'Existence of a legally valid arbitration chamber, implemented in the solution to resolve any conflicts in a cheap, efficient and fast way.',
          },
        ],
      },
      {
        title: 'EVO',
        subtitle:
          'EVO is a complete software for trading digital assets with a focus on crypto, yet absolutely portable for any other digital assets tokenized or not, such as bank bonds, inputs in general and even commodities such as surplus electricity.',
        link: 'evo',
        h4:
          'EVO is a complete software for trading digital assets with a focus on crypto, yet absolutely portable for any other digital assets tokenized or not, such as bank bonds, inputs in general and even commodities such as surplus electricity.',
        p1:
          'Our web platform has a robust order engine capable of managing 2000+ concurrent orders per minute in a basic infrastructure. Documented API and own library that facilitates integration of investment robots.',
        p2:
          'Our Mobile application is robust with all the functionality of the web platform in the palm of your hands.',
        features: [
          {
            title: 'Friendly Interface',
            subtitle:
              'The platform has a clean layout that includes a clear direction for beginners and more advanced users.',
          },
          {
            title: 'Freedom',
            subtitle:
              'The platform was designed to be adaptable. Customize the front-end environment to suit your demand.',
          },
          {
            title: 'Support',
            subtitle:
              'Senior support of up to 24 hours a day 7 days a week with immediate response time.',
          },
          {
            title: 'Wallet',
            subtitle:
              'Automatically generated wallet addresses; Googles two-factor secure authentication; Integrate cold storage wallets for added security.',
          },
          {
            title: 'Robust Order Engine',
            subtitle:
              'The algorithm implemented for order processing was researched and developed in-house in a way that supports 2000+ concurrent orders per minute in a basic infrastructure.',
          },
          {
            title: 'Sophisticated order types',
            subtitle:
              'Advanced trading tool with Market, Limit, Stop-Market, Stop-Limit and other orders on demand. It supports trading strategies that involve capital protection and allows users to sleep peacefully.',
          },
        ],
        featuresMid: [
          {
            title: 'Security by protocol',
            subtitle:
              'The platform was designed as one of the safety pillars of the solution as a whole. All information exchange is encrypted end to end with algorithms that are state of the art in legacy encryption like Diffie–Hellman.',
          },
          {
            title: 'Fluid trading',
            subtitle:
              'EVO has a robust order engine, backoffice / administrative, client area and integration with multiple decentralized protocols. In 2018, a bag with Evo technology had 64 different tokens listed.',
          },
          {
            title: 'Inviting customization',
            subtitle:
              'Platform with customizable interface with different technical elements for asset trading provided in three base languages: English, Spanish and Portuguese.',
          },
        ],
      },
    ],
  },
  sendMail: {
    title: 'Did is not receive the confirmation link? Click here to resend',
    success: 'Thanks for the intention! Soon we will contact you',
    error: 'An error was encountered while sending the email. Please try again later :(.',
    resend: 'Resend',
  },
  customers: {
    title: 'Our Customers',
    subtitle:
      'We deliver practical and accessible solutions to the market with maximum quality, agility and security.',
    testimony: [
      {
        name: 'Bernardo Castro Vitorino',
        title: 'CEO - Health Link International',
        testimonial:
          'The company was responsible for developing the blockchain performance recording platform that positions Tempus in the state of the art in financial transparency.',
      },
      {
        name: 'Leonardo I. R. de Carvalho',
        title: 'CEO, Nftfy - Decentralized NFT Fractionalization',
        testimonial:
          'Criptonomia brings together some of the greatest technical and business experts from Blockchain in Latin America. They are capable of delivering large projects within reasonable timeframes.',
      },
    ],
  },
  partners: {
    title: 'Our partners',
    subtitle: 'These are some of our partners that help us build our solutions.',
  },
  contactUs: {
    title: 'Contact us now!',
    adress: 'Alameda do Ingá, 16 - 2º andar Vale do Sereno, Nova Lima/MG',
    number: '+55 31 99707 6411',
    email: 'contato@criptonomia.com',
    name: 'Name:',
    emailForm: 'Email:',
    company: 'Company:',
    intention: 'Intention:',
    send: 'Send',
    asset: 'We know how to value men scarcest asset.',
  },
  testimony: {
    title: 'Some Testimonials',
  },
  footer: {
    allRights: '© Criptonomia 2021. All Rights Reserved',
    follow: 'Follow us',
  },
  mission: {
    obj: [
      {
        title: 'Our mission',
        subtitle:
          'Attack corporate problems of difficult resolution, high value added and offer technologies that promote excellence and transactional fluidity.',
      },
      {
        title: 'Our vision',
        subtitle:
          'Criptonomia aims to be a reference in troubleshooting that can be treated through state-of-the-art technologies and processes with emphasis on distributed protocols.',
      },
      {
        title: 'Because we',
        subtitle:
          'Because we execute. We tangible projects based on abstract technologies in applications that generate real value.',
      },
    ],
  },
  links: [
    {
      title: 'Home',
      route: '/home',
    },
    {
      title: 'About',
      route: '/about',
    },
    {
      title: 'Products',
      route: '/products',
    },
    {
      title: 'Contact',
      route: '/contact',
    },
  ],
};
